import React from 'react';
import { Link } from 'react-router-dom';

/**
 * data Columns for grid and mobile view
 * @type {React.FC<Props>}
 * @returns {React.ReactElement} The Data Columns Array
 */
export const DataColumns = ({ getBaseURL, getRepoName }) => {
  const dataColumns = [
    {
      field: 'bug_id',
      title: 'Bug ID',
      editable: false,
      show: true,
      width: '80px',
      minResizableWidth: 150,
      filterable: true,
      className: 'grid-cells',
      cell: (props) => (
        <td className="link-column">
          <>
            <Link to={props.dataItem.bug_url} target="_blank">
              {props.dataItem.bug_id}
            </Link>
          </>
        </td>
      ),
    },
    {
      field: 'file_path',
      title: 'File Name',
      editable: false,
      show: true,
      width: '200px',
      minResizableWidth: 50,
      filterable: true,
      cell: (props) => (
        <td className="link-column">
          <>
            <Link to={props.dataItem.file_url} target="_blank">
              {props.dataItem.file_path}
            </Link>
          </>
        </td>
      ),
    },
    {
      field: 'repo_name',
      title: 'Project/Repos',
      editable: false,
      show: true,
      width: '100px',
      minResizableWidth: 250,
      filterable: true,
      className: 'grid-cells',
    },
    {
      field: 'action',
      title: 'Action',
      editable: false,
      show: true,
      width: '50px',
      minResizableWidth: 250,
      filterable: false,
      className: 'grid-cells',
      excludeFromFilter: true,
    },
    {
      field: 'author',
      title: 'Author',
      editable: false,
      show: true,
      width: '50px',
      minResizableWidth: 250,
      filterable: false,
      className: 'grid-cells',
      excludeFromFilter: true,
    },
    {
      field: 'revision',
      title: 'Revision',
      editable: false,
      show: true,
      width: '50px',
      minResizableWidth: 250,
      filterable: false,
      className: 'grid-cells',
      excludeFromFilter: true,
    },
    {
      field: 'commit_date',
      title: 'Data/Time',
      editable: false,
      show: true,
      width: '100px',
      minResizableWidth: 250,
      filterable: false,
      className: 'grid-cells',
      excludeFromFilter: true,
    },
  ];

  return dataColumns;
};
export default DataColumns;
